export default {
  LIST(state, data) {
    state.topics = data
  },
  UPDATE(state, value) {
    state.topic = { ...value }
  },
  FRESH(state) {
    state.topic = { }
  },
  GET(state, data) {
    state.topic = data
  },
}
